import CommunicationErrorsTable from "./CommunicationErrorsTable";

export default function CommunicationErrorsLog(){
    return (<div>
        <CommunicationErrorsTable/>
    </div>)
}